// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chip--small[data-v-26765065] {\n  height: 22px;\n}\n.flight-direction[data-v-26765065] {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n.grey--text[data-v-26765065] {\n  color: #9e9e9e !important;\n}\n.bigger[data-v-26765065] {\n  margin-right: 4px;\n  font-size: 15px;\n}\n.flight-airport[data-v-26765065] {\n  font-weight: 700;\n  line-height: 1;\n}\n", ""]);
// Exports
module.exports = exports;
